import Vue from 'vue'
import VueRouter from 'vue-router'
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import { getUserLoginVerify, getUserRegisterVerify, isUserLoggedIn } from '@/auth/utils'
import Config from '../../config'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'داشبورد',
            active: true,
          },
        ],
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'داشبورد',
            active: true,
          },
        ],
      },
    },
    {
      path: '/profile',
      name: 'profile-view',
      component: () => import('@/views/profile/ProfileView.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'پروفایل',
            active: true,
          },
        ],
      },
    },
    {
      path: '/record/list',
      name: 'record-list',
      component: () => import('@/views/record/RecordList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'لیست تردد',
            active: true,
          },
        ],
      },
    },
    {
      path: '/record/list/personal',
      name: 'record-list-personal',
      component: () => import('@/views/record/RecordPersonal.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'لیست تردد',
            active: true,
          },
        ],
      },
    },
    {
      path: '/record/all',
      name: 'record-all',
      component: () => import('@/views/record/RecordAll.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'لیست تردد',
            active: true,
          },
        ],
      },
    },
    {
      path: '/company',
      name: 'company',
      component: () => import('@/views/company/Company.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'کسب و کار',
            active: true,
          },
        ],
      },
    },
    {
      path: '/company/add',
      name: 'company-add',
      component: () => import('@/views/company/CompanyAdd.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'ایجاد کسب و کار',
            active: true,
          },
        ],
      },
    },
    {
      path: '/company/list',
      name: 'company-list',
      component: () => import('@/views/company/CompanyList.vue'),
      meta: {
        pageTitle: 'Company',
        breadcrumb: [
          {
            text: 'Company',
            active: true,
          },
        ],
      },
    },
    {
      path: '/company/all',
      name: 'company-all',
      component: () => import('@/views/company/CompanyAll.vue'),
      meta: {
        pageTitle: 'Company',
        breadcrumb: [
          {
            text: 'Company',
            active: true,
          },
        ],
      },
    },
    {
      path: '/tick/map',
      name: 'tick-map',
      component: () => import('@/views/tick/TickMap.vue'),
      meta: {
        pageTitle: 'Add map',
        breadcrumb: [
          {
            text: 'Add map',
            active: true,
          },
        ],
      },
    },
    {
      path: '/office/list',
      name: 'office-list',
      component: () => import('@/views/office/OfficeList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'لیست محل کار',
            active: true,
          },
        ],
      },
    },
    {
      path: '/office/add',
      name: 'office-add',
      component: () => import('@/views/office/OfficeAdd.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'محل کار جدید',
            active: true,
          },
        ],
      },
    },
    {
      path: '/shift/list',
      name: 'shift-list',
      component: () => import('@/views/shift/ShiftList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'لیست شیفت ها',
            active: true,
          },
        ],
      },
    },
    {
      path: '/shift/add',
      name: 'shift-add',
      component: () => import('@/views/shift/ShiftAdd.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'افزدون شیفت',
            active: true,
          },
        ],
      },
    },
    {
      path: '/user/list',
      name: 'user-list',
      component: () => import('@/views/user/UserList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'لیست کارمندان',
            active: true,
          },
        ],
      },
    },
    {
      path: '/user/all',
      name: 'user-all',
      component: () => import('@/views/user/UserAll.vue'),
      meta: {
        pageTitle: 'User list',
        breadcrumb: [
          {
            text: 'User list',
            active: true,
          },
        ],
      },
    },
    {
      path: '/user/add',
      name: 'personal-add',
      component: () => import('@/views/user/PersonalAdd.vue'),
      meta: {
        pageTitle: 'Add personal',
        breadcrumb: [
          {
            text: 'Add personal',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/authentication/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/authentication/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/login-verify',
      name: 'login-verify',
      component: () => import('@/views/authentication/Login-Verify.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/register-verify',
      name: 'register-verify',
      component: () => import('@/views/authentication/Register-Verify.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    if (isUserLoggedIn()) {
      if (Config.isAppEmployee) {
        router.push({ path: '/tick/map' })
      } else {
        router.push({ path: '/dashboard' })
      }
    }
    return next()
  }
  if (to.path === '/register') {
    if (isUserLoggedIn()) {
      if (Config.isAppEmployee) {
        router.push({ path: '/tick/map' })
      } else {
        router.push({ path: '/dashboard' })
      }
    }
    return next()
  }
  if (to.path === '/register-verify') {
    if (isUserLoggedIn()) {
      if (Config.isAppEmployee) {
        router.push({ path: '/tick/map' })
      } else {
        router.push({ path: '/dashboard' })
      }
    }
    return next()
  }
  if (to.path === '/login-verify') {
    if (isUserLoggedIn()) {
      if (Config.isAppEmployee) {
        router.push({ path: '/tick/map' })
      } else {
        router.push({ path: '/dashboard' })
      }
    }
    return next()
  }

  if (!isUserLoggedIn()) {
    router.push({ path: '/login' })
  }
  // اتصال سوکت
  /* Establish Connection */
  /*
  if (isUserLoggedIn() && !Vue.prototype.$socket) {
    Vue.use(new VueSocketIO({
      debug: false,
      connection: SocketIO(`${Config.socketServers.server1.url}:${Config.socketServers.server1.port}`, {
        transportOptions: {
          polling: {
            extraHeaders: {
              Authorization: isUserLoggedIn().token,
            },
          },
        },
      }),
      vuex: {
        store,
      },
      options: {},
    }))
  }
  */

  return next()
})

export default router
